// tslint:disable
/**
 * IndoqaDemosAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
    LocationAutocompleteResultItem,
} from './';

/**
 * @export
 * @interface LocationAutocompleteScenario
 */
export interface LocationAutocompleteScenario {
    /**
     * @type {string}
     * @memberof LocationAutocompleteScenario
     */
    context?: string;
    /**
     * @type {string}
     * @memberof LocationAutocompleteScenario
     */
    query?: string;
    /**
     * @type {string}
     * @memberof LocationAutocompleteScenario
     */
    type?: LocationAutocompleteScenarioTypeEnum;
    /**
     * @type {Array<LocationAutocompleteResultItem>}
     * @memberof LocationAutocompleteScenario
     */
    items?: Array<LocationAutocompleteResultItem>;
}

/**
 * @export
 * @enum {string}
 */
export enum LocationAutocompleteScenarioTypeEnum {
    UnknownNumberZip = 'UNKNOWN_NUMBER_ZIP',
    UnknownString = 'UNKNOWN_STRING',
    OnlyZip = 'ONLY_ZIP',
    OnlyStreet = 'ONLY_STREET',
    OnlyCity = 'ONLY_CITY',
    OnlyPlace = 'ONLY_PLACE',
    OnlyZipStreet = 'ONLY_ZIP_STREET',
    FixedZip = 'FIXED_ZIP',
    FixedCity = 'FIXED_CITY',
    FixedStreet = 'FIXED_STREET',
    FixedPlace = 'FIXED_PLACE',
    FixedZipStreet = 'FIXED_ZIP_STREET'
}

